import React from "react";
import { List, Card, Col, Typography, Progress, Button, Avatar, Space, Empty } from "antd";
import { ApartmentOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import { formatDateOnly } from "Common/Components/FormatDateTime";
import { useNavigate } from "react-router-dom";
const { Text } = Typography;
export const TrainingSection = ({ activeTrainings, darkMode }) => {
  const navigate = useNavigate();
  const styles = {
    card: {
      borderRadius: 8,
      marginBottom: 24,
      backgroundColor: darkMode ? "#1f1f1f" : "#fff",
      borderColor: darkMode ? "#303030" : "#f0f0f0",
    },
    cardTitle: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    trainingCard: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    },
    listItem: {
      padding: "8px 0",
      borderBottom: `1px solid ${darkMode ? "#303030" : "#f0f0f0"}`,
    },
    avatarIcon: {
      backgroundColor: darkMode ? "#2a2a2a" : "#f0f0f0",
      color: darkMode ? "#ffffff" : "#1890ff",
    },
    textColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.85)" : undefined,
    },
    secondaryTextColor: {
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "rgba(0, 0, 0, 0.45)",
    },
    noData: {
      textAlign: "center",
      padding: "24px 0",
      color: darkMode ? "rgba(255, 255, 255, 0.45)" : "#999",
    },
    footer: {
      display: "flex",
      justifyContent: "flex-end",
      paddingTop: "16px",
      borderTop: `1px solid ${darkMode ? "#303030" : "#f0f0f0"}`,
      marginTop: "auto",
    },
  };
  return (
    <Col xs={24} lg={16}>
      <Card
        title={
          <Space style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={styles.cardTitle}>All Trainings</span>
          </Space>
        }
        style={{ ...styles.card, ...styles.trainingCard }}
        headStyle={styles.cardTitle}
      >
        {activeTrainings.length === 0 ? (
          <Empty description="No Trainings Available" />
        ) : (
          <>
            <List
              itemLayout="horizontal"
              dataSource={activeTrainings.slice(0, 3)}
              renderItem={(training) => (
                <List.Item style={styles.listItem} className="clickable-list-item">
                  <List.Item.Meta
                    avatar={<Avatar icon={<ApartmentOutlined />} style={styles.avatarIcon} />}
                    title={
                      <Text strong style={styles.textColor}>
                        {training.title}
                      </Text>
                    }
                    description={
                      <>
                        <Progress
                          percent={training.progress}
                          size="small"
                          strokeColor={darkMode ? "#ffffff" : "#1890ff"}
                          format={(percent) => (
                            <span
                              style={{
                                color: darkMode ? "#ffffff" : "#000000",
                              }}
                            >
                              {percent}% complete
                            </span>
                          )}
                        />
                        <Text style={styles.secondaryTextColor}>
                          {training.totalLearners} learners • Ends on:{" "}
                          {`${formatDateOnly(training.endDate)}`}
                        </Text>
                      </>
                    }
                  />
                </List.Item>
              )}
            />
            {activeTrainings.length >= 3 && (
              <div style={styles.footer}>
                <Button
                  type="link"
                  onClick={() =>
                    navigate("/training-section-list", {
                      state: { darkMode, activeTrainings },
                    })
                  }
                >
                  View All Trainings
                </Button>
              </div>
            )}
          </>
        )}
      </Card>
    </Col>
  );
};
TrainingSection.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  activeTrainings: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      progress: PropTypes.number.isRequired,
      endDate: PropTypes.string.isRequired,
      totalLearners: PropTypes.number.isRequired,
    })
  ).isRequired,
};
